import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../../table/FilteringTable/filtering.css";
import { Button, Dropdown } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../../config";
import { useDispatch } from "react-redux";
import { logoutonexpire } from "../../../../store/actions/AuthActions";
import { toast } from "react-toastify";
const ApplicationDetails = () => {
  const { type, id } = useParams();
  const [studentList, setStudentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const [studentsPerPage, setStudentsPerPage] = useState(10); // Can be updated with dropdown
  const [loading, setLoading] = useState(false);
  const [totalstudents, setTotalstudents] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const [jobType, setJobType] = useState(
    type == "student" ? "Select Activity" : "like",
  );
  const [jobName, setJobName] = useState(
    (() => {
      switch (type) {
        case "student":
          return "Select Activity";
        case "job":
          return "Job Interested";
        case "applied":
          return "Resume Sent";
        case "drive":
          return "Job Interested";
        default:
          return "Select Activity";
      }
    })(),
  );
  const maxPagesToShow = 10;

  const fetchStudentList = async (id) => {
    // const payload = {
    //   offset: currentPage * studentsPerPage,
    //   limit: studentsPerPage,
    // };
    setLoading(true);
    const params = {
      offset: currentPage * studentsPerPage,
      limit: studentsPerPage,
      [type == "student"
        ? "student_id"
        : type == "drive"
          ? "campus_drive_id"
          : "job_id"]: id,
    };

    if (jobType !== null && jobType !== "Select Activity") {
      params.filter_by_activity = jobType;
    }
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    // console.log(params);
    try {
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/Jobs/get_job_analysis_student`,
        {
          params,
          headers: {
            Authorization: authToken,
          },
        },
      );

      let jsonData;
      if (typeof response.data === "string") {
        let cleanedData = response.data.replace(/\[\]$/, "").trim();
        jsonData = JSON.parse(cleanedData);
      } else {
        jsonData = response.data;
      }
      const { data, totalRecords } = jsonData;
      setStudentData(data || []);
      // console.log(data);
      setTotalstudents(totalRecords);
      // setCurrentPage(0); // Reset the current page
    } catch (err) {
      if (err?.response?.status === 401) {
        dispatch(logoutonexpire());
      }
      console.error("Error fetching student list:", err);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(totalstudents / studentsPerPage);

  const indexOfLastStudent = (currentPage + 1) * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  // const currentStudents = studentList?.slice(
  //   indexOfFirstStudent,
  //   indexOfLastStudent > totalStudents ? totalStudents : indexOfLastStudent
  // );

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber < totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleStudentsPerPageChange = (event) => {
    setStudentsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to the first page when page size changes
  };

  //   useEffect(() => {
  //   fetchStudentList(id);
  // }, [currentPage]);

  const renderPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(0, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages - 1, startPage + maxPagesToShow - 1);

    if (startPage > 0)
      pages.push(
        <span key="start-ellipsis" style={{ fontSize: 24 }}>
          ...
        </span>,
      );

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Link
          key={i}
          to="#"
          className={`paginate_button ${i === currentPage ? "bg-white" : ""}`}
          onClick={() => handlePageChange(i)}
        >
          {i + 1}
        </Link>,
      );
    }

    if (endPage < totalPages - 1)
      pages.push(
        <span key="end-ellipsis" style={{ fontSize: 24 }}>
          ...
        </span>,
      );

    return pages;
  };

  const exportCSV = async () => {
    const params = {
      // offset: currentPage * studentsPerPage,
      // limit: studentsPerPage,
      [type == "student"
        ? "student_id"
        : type == "drive"
          ? "campus_drive_id"
          : "job_id"]: id,
      export_required: 1,
    };

    if (jobType !== null && jobType !== "Select Activity") {
      params.filter_by_activity = jobType;
    }
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    // console.log(params);
    try {
      setIsExporting(true);
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/Jobs/get_job_analysis_student`,
        {
          params,
          headers: {
            Authorization: authToken,
          },
        },
      );
      let jsonData;
      if (typeof response.data === "string") {
        let cleanedData = response.data.replace(/\[\]$/, "").trim();
        jsonData = JSON.parse(cleanedData);
      } else {
        jsonData = response.data;
      }
      console.log(jsonData);
      if (jsonData && jsonData?.csv_file_path) {
        const csvFilePath = jsonData.csv_file_path;
        const link = document.createElement("a");
        link.href = csvFilePath;
        link.setAttribute("download", "student_activity.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        toast.error("No data available for export.");
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        dispatch(logoutonexpire());
      }
      console.error("Error fetching student list:", err);
      setIsExporting(false);
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    if (id) {
      // Check if 'id' is not null or undefined
      fetchStudentList(id); // Call fetchStudentList with 'id'
    }
  }, [id, jobType, currentPage]); // 'jobType' is included in dependencies but not necessarily used directly

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="fs-22 mb-0">Student Activity</h4>
        <div className="d-flex align-items-center gap-3">
          <div>
            <Dropdown
              className="form-control border-0 w-100 d-flex align-items-center cursor-pointer"
              style={{ height: "40px" }}
            >
              <Dropdown.Toggle
                as="div"
                className="font-w600 text-primary justify-content-between d-flex align-items-center i-false"
              >
                {jobName}
                <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setJobType("Select Activity");
                    setJobName("Select Activity");
                  }}
                >
                  Select Activity
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setJobType("view");
                    setJobName("Job Visited");
                  }}
                >
                  Job Visited
                </Dropdown.Item>

                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setJobType("share");
                    setJobName("Job Shared");
                  }}
                >
                  Job Shared
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setJobType("like");
                    setJobName("Job Interested");
                  }}
                >
                  Job Interested
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setJobType("SendResume");
                    setJobName("Resume Sent");
                  }}
                >
                  Resume Sent
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setJobType("CallHR");
                    setJobName("Contacted HR");
                  }}
                >
                  Contacted HR
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="d-flex align-items-center">
            <Button
              variant="primary"
              size="sm"
              disabled={isExporting || loading}
              onClick={exportCSV}
            >
              <i className="fas fa-file-export me-2"></i>
              {isExporting ? "Exporting..." : "Export"}
            </Button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : studentList && studentList.length > 0 ? (
        <div
          className="table-responsive dataTables_wrapper"
          id="application-data"
        >
          <table className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table dataTable no-footer">
            <thead>
              <tr role="row">
                <th className="sorting_asc">Activity</th>
                <th className="sorting_asc text-center">Message</th>
                <th className="sorting_asc">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {studentList?.map((student, index) => (
                <tr role="row" key={index} className="odd">
                  <td>{student.analysis_type}</td>
                  <td>{student.message}</td>
                  <td>{student.created_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-sm-flex text-center justify-content-between align-items-center">
            <div className="dataTables_info" id="example5_info">
              Showing {indexOfFirstStudent + 1} to{" "}
              {Math.min(indexOfLastStudent, totalstudents)} of {totalstudents}{" "}
              entries
            </div>
            <div className="dataTables_paginate paging_simple_numbers">
              <Link
                to="#"
                className={`paginate_button previous ${
                  currentPage === 0 ? "disabled" : ""
                }`}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </Link>
              <span>{renderPageNumbers()}</span>
              <Link
                to="#"
                className={`paginate_button next ${
                  currentPage + 1 >= totalPages ? "disabled" : ""
                }`}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </Link>
            </div>
            <div class="form-group d-flex align-items-center">
              <label class="mr-2 mb-0" for="studentsPerPage">
                Show
              </label>
              <select
                id="studentsPerPage"
                style={{
                  marginRight: "10px",
                  marginLeft: "10px",
                  backgroundColor: "white",
                  borderRadius: 0,
                  border: "1px solid #cccccc",
                }}
                value={studentsPerPage}
                onChange={handleStudentsPerPageChange}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <label class="ml-2 mb-0">entries per page</label>
            </div>
          </div>
        </div>
      ) : (
        <div>No Student Activity Found</div>
      )}
    </>
  );
};

export default ApplicationDetails;
